import React, { useState, FC, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@material-ui/core";
import {colorInputBorder} from "../../Constants/theme";

const useStyles = makeStyles({
    dialog: {
        padding: "30px"
    },
    dialogTitle: {
        fontSize: "24px",
        fontWeight: "bold"
    },
    dialogMessage: {
        fontSize: "19px",
        letterSpacing: "-0.078px"
    },
    button: {
        padding: "12px 32px",
        color: colorInputBorder,
        border: `1px solid ${colorInputBorder}`
    }
});

// eslint-disable-next-line react/prop-types
const SchedulePopUp = ({message = "", title = "", isOpen, className="", setOpenDialog})  => {
    const classes = useStyles();

    const [dialogMessage, setDialogMessage] = useState(message);
    const [dialogTitle, setDialogTitle] = useState(title);

    const handleClose = () => {
        setOpenDialog(false);
    };

    useEffect(() => {
        setDialogTitle(title);
        setDialogMessage(message);
        setOpenDialog(isOpen);
    }, [dialogTitle, dialogMessage, isOpen]);

    return (
        <Dialog
            open={isOpen}
            disableEnforceFocus
            onClose={handleClose}
            classes={{paper: classes.dialog}}
        >
            <DialogTitle color="primary" classes={{root: classes.dialogTitle}}>
                <Typography variant="h3">
                    {dialogTitle}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText classes={{root: classes.dialogMessage}}>
                    {dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" variant="outlined" classes={{root: classes.button}}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SchedulePopUp;
